module.exports = function() {
  return new Worker(__webpack_public_path__ + "059a4312aeba92fc16b7.worker.js");
};